/**
 * @generated SignedSource<<9a8884f5c5737d2e237ecd1bfc22bf0c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSharedUrgencySignals_item$data = ReadonlyArray<{
  readonly isOnHold: boolean | null;
  readonly isSold: boolean | null;
  readonly isUnavailable: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "useSharedUrgencySignals_item";
}>;
export type useSharedUrgencySignals_item$key = ReadonlyArray<{
  readonly " $data"?: useSharedUrgencySignals_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSharedUrgencySignals_item">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useSharedUrgencySignals_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOnHold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnavailable",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "bd02891a503f7d40dfee9b15a720db91";

export default node;
